<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="pollinationForm" :refresh-key="refreshKey" :show-expand="false" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                pollinationForm: () => import('../forms/PollinationForm'),
                headers: [
                    { text: 'Load Movement', value: 'loadMovementId', table: 'loadMovements', form: () => import('../forms/LoadMovementForm') },
                    { text: 'Number Of Hives', value: 'numberOfHives' },
                    { text: 'Agreement File', value: 'agreementFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: 'Start On', value: 'startOn', format: this.formatDate },
                    { text: 'End On', value: 'endOn', format: this.formatDate },
                    { text: 'Are Hives Healthy', value: 'areHivesHealthy' },
                    { text: 'Are Hives Strong', value: 'areHivesStrong' },
                    { text: 'Conditions', value: 'conditions' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    loadMovements: [],
                    items: []
                },
                sorting: [
                    { column: "startOn", direction: "descending" },
                    { column: "conditions", direction: "ascending" },
                    { column: "loadMovementId", direction: "ascending" },
                ],
                itemsField: 'pollinations',
                editPageName: 'pollination',
                apiMethod: 'Pollinations',
                claimName: 'Pollinations',
                formTitle: 'Pollination',
                excelTitle: 'Pollinations',
                hasEditPage: false,
            }
        },
    };
</script>
